<template>
  <Select
    ref="Select"
    size="large"
    class="iv-dropdowntree-wrapper"
    @on-open-change="onOpenChange"
    :clearable="showClear"
    @on-change="onChange"
    :disabled="disabled"
    :remote-method="remoteMethod"
    :filterable="filterable"
    @on-clear="onClear"
    :placement="placement"
    v-model="inValue">
    <Option
      v-show="hidden"
      :key="t + k.value"
      :value="k.value"
      v-for="(k, t) in selectlList">{{k.label}}</Option>
    <!-- 同步树 -->
    <TireTree
      v-if="treeType == 'tireTree'"
      :value="value"
      :url="url"
      :params="params"
      v-bind="$attrs"
      v-on="$listeners"
      @on-list="onList"
      @on-select="onSelect"
      @on-select-change="onSelectChange">
    </TireTree>
    <LazyTree
      v-else
      async
      :changeTree="false"
      :treeParams="treeParamsMap"
      :treeMap="treeMap"
      @on-select-change="handleCheckChange" />
  </Select>
</template>
<script>
import TireTree from './tire-tree'
import LazyTree from '@/components/lazy-tree'
export default {
  props: {
    url: {
      type: String,
      default: 'api-general/module/portal/user/outGetRadioList'
    },
    value: {
      type: [String, Array],
      default: ''
    },
    treeType: {
      type: String,
      default: 'tireTree'
    },
    params: {
      type: Object,
      default () {
        return {}
      }
    },
    showClear: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      remote: false,
      filterable: true,
      inValue: this.value,
      hidden: false,
      selectlList: [],
      treeData: [],
      treeToArrays: []
    }
  },
  watch: {
    value (val) {
      this.inValue = val
    }
  },
  created () {
    this.filterable = this.params.noRemote ?? true
  },
  components: {
    TireTree,
    LazyTree
  },
  methods: {
    onChange (data) {
      if (data) {
        this.setValue(data)
        this.$setRefs('Select', 'visible', false)
        this.$emit('on-change', data, this.selectlList)
      }
    },
    treeToArray (tree) {
      this.treeToArrays = []
      const expanded = datas => {
        if (datas && datas.length > 0) {
          datas.forEach(e => {
            !e.disabled && this.treeToArrays.push({
              label: e.title,
              value: e?.data?.itemCode
            })
            expanded(e.children)
          })
        }
      }
      expanded(tree)
      if (this.params.noRemote === false) {
        this.selectlList = this.treeToArrays.filter(item => item.value.indexOf(this.inValue) > -1)
      }
    },
    remoteMethod (query) {
      if (this.params.noRemote === false) {
        return undefined
      }
      this.remote = true
      let that = this
      if (query !== '') {
        setTimeout(() => {
          that.selectlList = that.treeToArrays.filter(item => item.label.indexOf(query) > -1)
          this.hidden = true
          setTimeout(() => {
            this.setOverflow(document.body, 'auto')
          }, 500)
        }, 200)
      } else {
        this.selectlList = []
      }
    },
    onList (data) {
      this.treeData = data
      this.treeToArray(data)
    },
    onSelect (item) {
      if (!this.remote) {
        this.setSelectList(this.getOptionList(this.getWarpArray(item)))
        this.setValue(item?.data?.itemCode)
      }
    },
    onClear () {
      // this.remote = false
      this.selectlList = []
      this.setValue('')
      this.$setRefs('Select', 'visible', false)
      this.$emit('on-clear')
    },
    onOpenChange (val) {
      // when window close, we must set body overflow
      if (val) {
        this.setOverflow(document.body, 'hidden')
        return
      }
      setTimeout(() => {
        this.setOverflow(document.body, 'auto')
      }, 500)
    },
    onSelectChange (data = []) {
      this.setSelectList(this.getOptionList(this.getWarpArray(data)))
      let value = this.selectlList[0]?.value
      this.setValue(value)
      this.$setRefs('Select', 'visible', false)
      this.$emit('on-change', value, this.selectlList)
    },
    getOptionList (data) {
      return data.map(item => ({
        label: item.title,
        value: item?.data?.itemCode
      }))
    },
    getWarpArray (item) {
      return Array.isArray(item) ? item : [item]
    },
    setSelectList (data) {
      this.selectlList = data
    },
    setValue (val) {
      this.inValue = ''
      this.$nextTick(() => {
        this.inValue = val
      })
    },
    setOverflow (el, val) {
      el.style.overflow = val
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'variable/layout.scss';
/deep/ .ivu-select-dropdown-list {
  @extend .iv-symbol-pl16;
  @extend .iv-symbol-pr16;
}
</style>
